/* NECCST FAQ accordion. Single-open per list: opening one closes the rest.
   Binds to every [data-faq-list] on the page, so multiple FAQ sections coexist.
   CSS does the height (grid-template-rows 0fr->1fr); JS only toggles .open + aria. */
(function () {
  function bind(list) {
    if (list.dataset.faqBound) return;
    list.dataset.faqBound = '1';
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-q');
      if (!btn || !list.contains(btn)) return;
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      list.querySelectorAll('.faq-item.open').forEach(function (el) {
        el.classList.remove('open');
        var b = el.querySelector('.faq-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }
  function init() {
    document.querySelectorAll('[data-faq-list]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
